import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { StepService } from 'src/app/components/stepper/step.service';

@Component({
  selector: 'app-info-card',
  templateUrl: './info-card.component.html',
  styleUrls: ['./info-card.component.scss']
})
export class InfoCardComponent implements OnInit {

  once = false;
  multiple = false;
  showBack = false;


  termsConditions = new FormControl(false, [Validators.required]);

  constructor(private stepService: StepService) { }

  ngOnInit(): void {
    if (localStorage.getItem("type") === 'once') {
      this.once = true;
    }

    if (localStorage.getItem("type") === 'multiple') {
      this.multiple = true;
    }
  }

  onSubmit() {
    if (this.termsConditions.valid && this.termsConditions.value) {
      this.stepService.nextStep();
    } 
  }

  edit() {
    this.stepService.prevStep();
     //hide back if redirected from filled info
    this.showBack = !this.showBack;
    this.stepService.toggle.next(this.showBack)
  }

  get user(): any {
    return JSON.parse(localStorage.getItem('policy'));
  }

}
